import {ProjectTypes} from './project-types.enum';

// inserire qui le tipologie del sito dove impostare onlyNetQuotes a true
export enum OnlyNetProjectTypes {
  GEO_BASIC = ProjectTypes.GEO_BASIC,
  GEO_BASIC_WIDGET = ProjectTypes.GEO_BASIC_WIDGET
}
